var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questions__intro-text"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xs-12"},[_c('p',[_vm._v("Click on the answer to each question below, then click on calculate.")])])])])
}]

export { render, staticRenderFns }